import { render, staticRenderFns } from "./GodzinyCennika.vue?vue&type=template&id=1a83880a&scoped=true&"
import script from "./GodzinyCennika.vue?vue&type=script&lang=js&"
export * from "./GodzinyCennika.vue?vue&type=script&lang=js&"
import style0 from "./GodzinyCennika.vue?vue&type=style&index=0&id=1a83880a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a83880a",
  null
  
)

export default component.exports